import { render, staticRenderFns } from "./menus-config.vue?vue&type=template&id=095507fd"
import script from "./menus-config.vue?vue&type=script&lang=js"
export * from "./menus-config.vue?vue&type=script&lang=js"
import style0 from "./menus-config.vue?vue&type=style&index=0&id=095507fd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports